import { render, staticRenderFns } from "./ComplaintTable.vue?vue&type=template&id=334077b3&"
import script from "./ComplaintTable.vue?vue&type=script&lang=js&"
export * from "./ComplaintTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports